import { Button } from "@/components/ui/button";
import { MapPin } from "lucide-react";
import { COMPANY } from "@/lib/company";

export default function AreasWeServe() {
  return (
    <section
      id="areas-we-serve"
      data-testid="areas-section"
      className="py-20 lg:py-28 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-8 mb-10 lg:mb-14">
          <div className="lg:col-span-6">
            <p className="text-[11px] uppercase tracking-[0.25em] text-[#C5A059] font-semibold mb-3">
              Coverage
            </p>
            <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight text-neutral-900 leading-[1.1]">
              Apartment &amp; Home Renovation Across Dubai
            </h2>
          </div>
          <div className="lg:col-span-6 flex items-end">
            <p className="text-base lg:text-lg text-neutral-600 leading-relaxed">
              {COMPANY.name} provides apartment renovation Dubai, home renovation Dubai, kitchen renovation, bathroom renovation, painting, flooring, gypsum ceiling, electrical, plumbing, and complete interior fit-out services across Dubai&apos;s residential communities.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-px bg-neutral-200 border border-neutral-200">
          {COMPANY.serviceAreas.map((area) => (
            <div
              key={area}
              data-testid={`area-${area.replace(/\s+/g, "-").toLowerCase()}`}
              className="bg-white p-4 lg:p-5 flex items-center gap-2.5 hover:bg-[#F9F8F6] transition-colors group"
            >
              <MapPin className="w-3.5 h-3.5 text-[#C5A059] flex-shrink-0" />
              <span className="text-sm text-neutral-800 leading-tight group-hover:text-[#C5A059] transition-colors">
                {area}, Dubai
              </span>
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <a href="#lead-form" data-testid="areas-cta">
            <Button className="bg-[#C5A059] hover:bg-[#A88746] text-white rounded-none px-7 py-6 font-medium">
              Request a Bespoke Consultation
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
}
